import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=6bb5041c&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=ts&"
export * from "./MenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=6bb5041c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5041c",
  null
  
)

export default component.exports